import React from 'react';
import { Link } from 'react-router-dom';
import { ChefHat, ArrowLeft } from 'lucide-react';

type LegalLayoutProps = {
  title: string;
  description: string;
  children: React.ReactNode;
};

const LegalLayout: React.FC<LegalLayoutProps> = ({ title, description, children }) => {
  return (
    <div className="min-h-screen bg-background relative overflow-hidden font-sans">
      {/* Dynamic Background Glow */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px] -z-10" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px] -z-10" />

      <div className="mx-auto max-w-4xl px-6 py-12 md:py-20 space-y-12 relative">
        
        {/* Header */}
        <header className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <Link to="/" className="group flex items-center gap-4 transition-transform active:scale-95">
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary shadow-lg shadow-primary/20 transition-all group-hover:rotate-6">
              <ChefHat className="h-6 w-6 text-white" />
            </div>
            <div>
              <p className="text-xl font-black text-white tracking-tighter">Garçom Digital</p>
              <p className="text-[10px] uppercase font-black tracking-[0.3em] text-primary/60">Compliance & Legal</p>
            </div>
          </Link>

          <Link
            to="/"
            className="group flex items-center gap-2 rounded-2xl border border-white/10 bg-white/5 px-6 py-3 text-sm font-bold text-white transition-all hover:bg-white/10 hover:border-white/20 active:scale-95"
          >
            <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            Voltar ao site
          </Link>
        </header>

        {/* Title Section */}
        <div className="space-y-4">
          <h1 className="text-4xl md:text-6xl font-black tracking-tighter text-white drop-shadow-sm">
            {title}
          </h1>
          <p className="max-w-3xl text-lg md:text-xl text-secondary/60 leading-relaxed font-medium font-sans">
            {description}
          </p>
        </div>

        {/* Content Container */}
        <div className="rounded-[40px] border border-white/10 bg-gradient-to-b from-white/[0.03] to-transparent p-8 md:p-12 shadow-2xl backdrop-blur-sm">
          <div className="prose prose-invert prose-primary max-w-none prose-headings:text-white prose-p:text-secondary/80 prose-strong:text-white prose-li:text-secondary/70">
            {children}
          </div>
        </div>

        {/* Simple Footer */}
        <footer className="pt-12 text-center border-t border-white/5">
          <p className="text-sm font-medium text-secondary/30 uppercase tracking-[0.2em]">
            © 2026 Gastroflow Technology Corp. Todos os direitos reservados.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default LegalLayout;
